module.exports = __webpack_public_path__ + "img/button_language_no.3105c6e2.svg";